import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "../../Axios/Axios";
import { Urls } from "../../Urls";
import classes from "./Signup.module.css";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  sendEmailVerification,
} from "firebase/auth";
import useMfa from "../../hooks/useMFA";
import OtpInput from "../Login/OtpInput";
import { auth } from "../firebase/firebase";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { isValidBusinessEmail, isRestrictedDomain, isPersonalEmailDomain } from "../../Utility";
import Loader from "../Loader";
import { Activity, currentRequestTimeStamp, LORRI_NUMBERS, resolveScreenParam } from "../../Constants";
import { mailerAPI } from "../Freightrates1/Utility";
import { useMixPanelForTracking } from "../../utils/TrackMixPanel";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
// import LoRRI_Image from "../../Content/images/LoRRI.png";
import AuthLeftPanel from "../AuthLeftPanel/AuthLeftPanel";
import { MFA_VERIFIED_KEY } from "../App";
import VerifyEmailScreen from "../Shared/VerifyEmailScreen";
// "form"         → main signup form  (active)
// "verify-email" → email verification pending (user must click link in inbox)
// "mfa-choice"   → TODO: POST SPRINT 2 — ask user if they want MFA (project MFA ON)
// "mfa-setup"    → TODO: POST SPRINT 2 — OTP entry for phone enrollment
// "success"      → TODO: POST SPRINT 2 — enrollment complete

const Signup = () => {
  const [email, setEmail] = useState("");
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [companyname, setcompanyname] = useState("");
  const [error, setError] = useState("");
  const [check, setcheck] = useState(false);
  const [show, setshow] = useState(false);
  const [promoCode, setPromoCode] = useState("ELSC");
  const [isPromoFromUrl, setIsPromoFromUrl] = useState(false);
  const [promoStatus, setPromoStatus] = useState(null);
  const [promoMessage, setPromoMessage] = useState("");
  const [isValidatingPromo, setIsValidatingPromo] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  // "form" is the default. "verify-email" is shown after account creation.
  const [signupStep, setSignupStep] = useState("form");

  // Stored after account creation so the mailer fires on verified goToHome
  const pendingMailerDataRef = useRef(null);

  // TODO: POST SPRINT 2 — MFA OTP state (re-enable after demos)
  // const [mfaOtp, setMfaOtp] = useState("");
  // const [mfaVerificationId, setMfaVerificationId] = useState(null);
  // const [mfaLoading, setMfaLoading] = useState(false);
  // const [mfaPhone, setMfaPhone] = useState("");
  // const mfaRecaptchaRef = useRef(null);

  // TODO: POST SPRINT 2 — project-level MFA status fetch (re-enable after demos)
  // Skipped during demos — signup goes straight to home regardless of MFA status.
  // const [projectMfaEnabled, setProjectMfaEnabled] = useState(false);
  // const [mfaStatusLoading, setMfaStatusLoading] = useState(true);
  // useEffect(() => {
  //   const fetchMfaStatus = async () => {
  //     setMfaStatusLoading(true);
  //     try {
  //       const response = await axios.get(Urls.getMfaStatus);
  //       setProjectMfaEnabled(response?.data?.status === true);
  //     } catch (err) {
  //       console.warn("MFA status fetch failed, defaulting to OFF:", err);
  //       setProjectMfaEnabled(false);
  //     } finally {
  //       setMfaStatusLoading(false);
  //     }
  //   };
  //   fetchMfaStatus();
  // }, []);

  const history = useHistory();
  const location = useLocation();
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  const [isCompanyAutofilled, setIsCompanyAutofilled] = useState(false);
  const [hasUserEditedCompany, setHasUserEditedCompany] = useState(false);

  const PUBLIC_DOMAINS = new Set([
    "gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "icloud.com",
    "zoho.com", "mail.com", "protonmail.com", "proton.me", "live.com",
    "aol.com", "yahoo.co.in", "gmail.co.in", "rediffmail.com", "yandex.com"
  ]);

  const getDerivedCompanyName = (emailVal) => {
    if (emailVal && emailVal.includes("@")) {
      const parts = emailVal.split("@");
      if (parts.length === 2) {
        const domain = parts[1].toLowerCase().trim();
        if (domain && domain.includes(".")) {
          if (!PUBLIC_DOMAINS.has(domain)) {
            const domainName = domain.split(".")[0];
            if (domainName && domainName.length >= 2) {
              return domainName.toUpperCase();
            }
          }
        }
      }
    }
    return "";
  };

  useEffect(() => {
    if (hasUserEditedCompany) return;
    if (email && email.includes("@")) {
      const parts = email.split("@");
      if (parts.length === 2) {
        const domain = parts[1].toLowerCase().trim();
        if (domain && domain.includes(".")) {
          if (!PUBLIC_DOMAINS.has(domain)) {
            const domainName = domain.split(".")[0];
            if (domainName && domainName.length >= 2) {
              setcompanyname(domainName.toUpperCase());
              setIsCompanyAutofilled(true);
              return;
            }
          }
        }
      }
    }
    if (isCompanyAutofilled) {
      setcompanyname("");
      setIsCompanyAutofilled(false);
    }
  }, [email, hasUserEditedCompany]);

  useEffect(() => {
    TrackMixPanel({
      ModuleName: "signup",
      ScreenName: "signup",
      Data: `None`,
      Definition: "user has clicked on signup button",
    });
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "auto";
    return () => { document.body.style.overflow = originalOverflow; };
  }, []);

  const validatePasswordStrength = () => true;

  const nameValidation = () => {
    if (!name.trim()) {
      setError("Please enter your name to proceed.");
      return false;
    }
    return true;
  };


  const COMPANY_NAME_LIMITS = { min: 2, max: 100 };
  const COMPANY_PLACEHOLDERS = new Set(["test", "testing", "na", "n/a", "null", "company", "mycompany", "asdf"]);
  const normalizeCompany = (s) => (s ?? "").toString().trim().split(" ").filter(Boolean).join(" ");
  const displayValidation = () => true;

  const companyValidation = () => {
    const value = normalizeCompany(companyname);
    if (value.length < COMPANY_NAME_LIMITS.min || value.length > COMPANY_NAME_LIMITS.max) {
      toast.error(`Company Name must be between ${COMPANY_NAME_LIMITS.min} and ${COMPANY_NAME_LIMITS.max} characters.`);
      return false;
    }
    if (!new RegExp("[A-Za-z]").test(value)) {
      toast.error("Company Name must include at least one letter.");
      return false;
    }
    if (!new RegExp("^[A-Za-z0-9 .,&'()/-]+$").test(value)) {
      toast.error("Use only letters, numbers, spaces, and . , & ' ( ) / - characters.");
      return false;
    }
    if (new RegExp("^[.,&'()/-]").test(value) || new RegExp("[.,&'()/-]$").test(value)) {
      toast.error("Company Name cannot start or end with punctuation.");
      return false;
    }
    for (let i = 2; i < value.length; i++) {
      if (value[i] === value[i - 1] && value[i - 1] === value[i - 2]) {
        toast.error("Avoid repeating the same character 3 or more times in a row.");
        return false;
      }
    }
    if (COMPANY_PLACEHOLDERS.has(value.toLowerCase())) {
      toast.error("Please enter your official company name.");
      return false;
    }
    return true;
  };

  const normalizePhone = (s) => {
    const str = (s ?? "").toString();
    let out = "";
    for (let i = 0; i < str.length; i++) {
      const ch = str[i];
      if (ch >= "0" && ch <= "9") out += ch;
      else if (ch === "+" && out.length === 0) out = "+";
    }
    return out;
  };


  const validateEmailAddress = (emailVal) => !isValidBusinessEmail(emailVal);

  const emailValidation = (emailVal) => {
    if (!emailVal.trim()) {
      setError("Please enter your work email to proceed.");
      return false;
    }
    if (isPersonalEmailDomain(emailVal)) {
      setError("Please enter a business email address.");
      return false;
    }
    if (isRestrictedDomain(emailVal)) {
      setError("Your email domain is not authorized to access LoRRI.");
      const attempted_at = new Date().toLocaleString();
      mailerAPI({
        activity: "Email Request",
        type: "superlaunch",
        mail_status: "Pending",
        from_email: "connect@logisticsnow.in",
        user_type: "company",
        subject: `Blocked Domain Signup Alert: ${emailVal} attempted to access LoRRI`,
        content: `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"/><meta name="viewport" content="width=device-width, initial-scale=1.0"/><meta name="color-scheme" content="only light"/><meta name="supported-color-schemes" content="only light"/><title>Blocked Domain Signup Attempt</title></head><body style="margin:0;padding:0;background-color:#f3f6fb;font-family:'Segoe UI',Arial,sans-serif;color:#172033;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#f3f6fb" style="background-color:#f3f6fb;padding:40px 16px;"><tr><td align="center"><table width="580" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#ffffff" style="width:100%;max-width:580px;background-color:#ffffff;border:1px solid #d8e0ec;border-radius:16px;overflow:hidden;box-shadow:0 10px 28px rgba(23,32,51,0.08);"><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:30px 34px 22px;border-top:5px solid #dc2626;border-bottom:1px solid #e6edf5;"><p style="margin:0 0 8px;font-size:11px;font-weight:800;letter-spacing:1.6px;text-transform:uppercase;color:#dc2626;">Internal Notification</p><h1 style="margin:0;font-size:25px;line-height:1.3;font-weight:800;color:#172033;">Blocked Domain Signup Attempt</h1><p style="margin:10px 0 0;font-size:14px;line-height:1.6;color:#526071;">A signup attempt was blocked on the LoRRI platform due to an unauthorized domain.</p></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:22px 34px 0;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#fff7f7" style="background-color:#fff7f7;border:1px solid #fecaca;border-radius:12px;"><tr><td style="padding:15px 18px;border-left:4px solid #dc2626;"><p style="margin:0;font-size:14px;line-height:1.5;font-weight:800;color:#b91c1c;">Signup blocked — domain not authorized</p><p style="margin:4px 0 0;font-size:13px;line-height:1.5;color:#526071;">Review the details below for internal records.</p></td></tr></table></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:26px 34px 10px;"><p style="margin:0 0 14px;font-size:12px;font-weight:800;letter-spacing:1.1px;text-transform:uppercase;color:#334155;">Attempt Details</p><table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;"><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Email</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;word-break:break-word;"><a href="mailto:${emailVal}" style="color:#dc2626;text-decoration:none;">${emailVal}</a></td></tr></table></td></tr><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;border-bottom:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Attempted At</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;color:#172033;word-break:break-word;">${attempted_at}</td></tr></table></td></tr></table></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:18px 34px 28px;"><p style="margin:0;font-size:12px;line-height:1.6;color:#7b8794;text-align:center;">This is an automated internal alert from LoRRI. Please do not reply to this email.</p></td></tr><tr><td bgcolor="#f8fafc" style="background-color:#f8fafc;border-top:1px solid #e5eaf2;padding:15px 34px;text-align:center;"><p style="margin:0;font-size:12px;line-height:1.5;font-weight:800;color:#1a3c6e;">Team LoRRI <span style="color:#a3adba;">&bull;</span> LogisticsNow</p></td></tr></table></td></tr></table></body></html>`,
        Application_name: "lorri",
        module_name: "Signup",
        timestamp: currentRequestTimeStamp(),
        to_email: "raj@logisticsnow.ai",
        cc: [
          "radhika@logisticsnow.ai",
          "anvit@logisticsnow.ai",
          "sanket@logisticsnow.ai",
          "smeet@logisticsnow.ai",
          "shaleen@logisticsnow.ai",
          "akhil@logisticsnow.ai",
          "tejas@logisticsnow.ai",
          "saima@logisticsnow.ai",
        ],
      }, null);
      return false;
    }
    if (!isValidBusinessEmail(emailVal)) {
      setError("Please enter a business email as you@company.com");
      return false;
    }
    return true;
  };

  const { enrollPhoneSendOtp, enrollPhoneVerifyOtp, resetRecaptchaVerifier } = useMfa();

  const register = async (emailVal) => {
    setshow(true);

    if (emailVal.length > 50) {
      toast.error("Email cannot exceed 50 characters.");
      setshow(false);
      return;
    }

    const finalCompanyName = companyname.trim() ? companyname.trim() : getDerivedCompanyName(emailVal);
    if (finalCompanyName.length > 100) {
      toast.error("Company Name cannot exceed 100 characters.");
      setshow(false);
      return;
    }

    setError("");

    if (!nameValidation()) { setshow(false); return; }
    if (!emailValidation(emailVal)) { setshow(false); return; }
    if (!password.trim()) { setError("Please create a password to proceed."); setshow(false); return; }
    if (!companyValidation(finalCompanyName)) { setshow(false); return; }

    if (promoCode.trim()) {
      localStorage.setItem("applied_promo_code", promoCode.trim());
    }

    TrackMixPanel({
      ModuleName: "signup",
      ScreenName: "signup",
      Data: `email: ${emailVal}${promoCode.trim() ? `, promoCode: ${promoCode.trim()}` : ""}`,
      Definition: "user has signed up successfully!",
    });

    try {
      const res = await createUserWithEmailAndPassword(auth, emailVal, password);
      const user = auth.currentUser;

      if (promoCode && promoCode.trim() !== "") {
        try {
          const apiUrl = `${Urls.user_data}?referral_code=${encodeURIComponent(promoCode.trim())}`;
          await axios.post(apiUrl, {
            email: emailVal,
            user_id: user.uid,
            company_name: finalCompanyName || "",
            user_name: name || ""
          });
        } catch (apiError) {
          console.error("User API Error:", apiError);
        }
      }

      await updateProfile(user, { displayName: name });

      // Send verification email and show the verify-email step.
      // goToHome (and the signup alert mailer) fires only after the user
      // confirms their email is verified — see handleSignupVerified below.
      await sendEmailVerification(user);

      sessionStorage.setItem("accessToken", res.user.accessToken);
      localStorage.setItem("user_name", name);

      // Store mailer data so we can fire it in handleSignupVerified
      pendingMailerDataRef.current = {
        alert_user_name: name,
        alert_user_email: emailVal,
        alert_company_name: finalCompanyName,
      };

      setshow(false);
      toast.success("Account created! Please verify your email to continue.");
      setSignupStep("verify-email");

    } catch (err) {
      setshow(false);
      if (err.code === "auth/email-already-in-use") setError("This email is already registered. Try signing in instead.");
      else if (err.code === "auth/invalid-email") setError("The email address is not valid.");
      else if (err.code === "auth/operation-not-allowed") setError("Sign-up is currently disabled. Please contact support.");
      else if (err.code === "auth/weak-password") setError("Please enter at least 8 characters, including one special character and one number");
      else if (err.code === "auth/password-does-not-meet-requirements") {
        const parts = [];
        if (err.message.includes("8 characters")) parts.push("at least 8 characters");
        if (err.message.includes("numeric")) parts.push("a number");
        if (err.message.includes("non-alphanumeric") || err.message.includes("special")) parts.push("a special character");
        if (err.message.includes("uppercase")) parts.push("an uppercase letter");
        if (err.message.includes("lowercase")) parts.push("a lowercase letter");
        if (parts.length > 0) {
          const last = parts.pop();
          const list = parts.length > 0 ? `${parts.join(", ")}, and ${last}` : last;
          setError(`Password must contain ${list}.`);
        } else {
          setError("Password does not meet requirements. Use 8+ characters with letters, numbers, and a special character.");
        }
      }
      else if (err.code === "auth/too-many-requests") setError("Too many attempts. Please try again later.");
      else if (err.code === "auth/internal-error") setError("Please enter a password.");
      else setError("Registration failed. Please check your details and try again.");
    }
  };

  // Called by VerifyEmailScreen once user.reload() confirms emailVerified === true
  const handleSignupVerified = () => {
    // Fire the signup alert mailer now that the user is genuinely verified
    if (pendingMailerDataRef.current) {
      const { alert_user_name, alert_user_email, alert_company_name } = pendingMailerDataRef.current;
      const signed_up_at = new Date().toLocaleString();
      const signupAlertBase = {
        activity: "Email Request",
        type: "superlaunch",
        mail_status: "Pending",
        from_email: "connect@logisticsnow.in",
        user_type: "company",
        subject: `New Signup Alert: ${alert_user_name} from ${alert_company_name} just joined LoRRI`,
        content: `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"/><meta name="viewport" content="width=device-width, initial-scale=1.0"/><meta name="color-scheme" content="only light"/><meta name="supported-color-schemes" content="only light"/><title>New User Signup Alert</title></head><body style="margin:0;padding:0;background-color:#f3f6fb;font-family:'Segoe UI',Arial,sans-serif;color:#172033;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#f3f6fb" style="background-color:#f3f6fb;padding:40px 16px;"><tr><td align="center"><table width="580" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#ffffff" style="width:100%;max-width:580px;background-color:#ffffff;border:1px solid #d8e0ec;border-radius:16px;overflow:hidden;box-shadow:0 10px 28px rgba(23,32,51,0.08);"><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:30px 34px 22px;border-top:5px solid #2563eb;border-bottom:1px solid #e6edf5;"><p style="margin:0 0 8px;font-size:11px;font-weight:800;letter-spacing:1.6px;text-transform:uppercase;color:#2563eb;">Internal Notification</p><h1 style="margin:0;font-size:25px;line-height:1.3;font-weight:800;color:#172033;">New User Signed Up</h1><p style="margin:10px 0 0;font-size:14px;line-height:1.6;color:#526071;">A new account has been created on the LoRRI platform.</p></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:22px 34px 0;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation" bgcolor="#f7faff" style="background-color:#f7faff;border:1px solid #dbeafe;border-radius:12px;"><tr><td style="padding:15px 18px;border-left:4px solid #2563eb;"><p style="margin:0;font-size:14px;line-height:1.5;font-weight:800;color:#1d4ed8;">Signup captured successfully</p><p style="margin:4px 0 0;font-size:13px;line-height:1.5;color:#526071;">Review the user information below for internal records.</p></td></tr></table></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:26px 34px 10px;"><p style="margin:0 0 14px;font-size:12px;font-weight:800;letter-spacing:1.1px;text-transform:uppercase;color:#334155;">User Details</p><table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;"><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Full Name</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;color:#172033;word-break:break-word;">${alert_user_name}</td></tr></table></td></tr><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Email</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;word-break:break-word;"><a href="mailto:${alert_user_email}" style="color:#2563eb;text-decoration:none;">${alert_user_email}</a></td></tr></table></td></tr><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Company</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;color:#172033;word-break:break-word;">${alert_company_name}</td></tr></table></td></tr><tr><td style="padding:14px 0;border-top:1px solid #e5eaf2;border-bottom:1px solid #e5eaf2;"><table width="100%" cellpadding="0" cellspacing="0" role="presentation"><tr><td width="36%" valign="top" style="font-size:13px;line-height:1.5;color:#64748b;padding-right:12px;">Signed Up At</td><td valign="top" style="font-size:14px;line-height:1.5;font-weight:800;color:#172033;word-break:break-word;">${signed_up_at}</td></tr></table></td></tr></table></td></tr><tr><td bgcolor="#ffffff" style="background-color:#ffffff;padding:18px 34px 28px;"><p style="margin:0;font-size:12px;line-height:1.6;color:#7b8794;text-align:center;">This is an automated internal alert from LoRRI. Please do not reply to this email.</p></td></tr><tr><td bgcolor="#f8fafc" style="background-color:#f8fafc;border-top:1px solid #e5eaf2;padding:15px 34px;text-align:center;"><p style="margin:0;font-size:12px;line-height:1.5;font-weight:800;color:#1a3c6e;">Team LoRRI <span style="color:#a3adba;">&bull;</span> LogisticsNow</p></td></tr></table></td></tr></table></body></html>`,
        Application_name: "lorri",
        module_name: "Signup",
        timestamp: currentRequestTimeStamp(),
      };

      mailerAPI({
        ...signupAlertBase,
        to_email: "raj@logisticsnow.in",
        cc: [
          "radhika@logisticsnow.ai",
          "anvit@logisticsnow.ai",
          "sanket@logisticsnow.ai",
          "smeet@logisticsnow.ai",
          "shaleen@logisticsnow.ai",
          "akhil@logisticsnow.ai",
          "tejas@logisticsnow.ai",
          "saima@logisticsnow.ai",
        ],
      }, null);

      pendingMailerDataRef.current = null;
    }

    toast.success("Email verified! Welcome to LoRRI.");
    goToHome();
  };

  // TODO: POST SPRINT 2 — re-enable MFA OTP send/verify after demos
  // const sendMfaOtp = async () => { ... };
  // const verifyMfaOtp = async () => { ... };

  // ── Navigation helpers ───────────────────────────────────────────────────────

  // const goToHome = () => { window.location.href = "/"; };
  // const goToHome = () => {
  //   localStorage.setItem(MFA_VERIFIED_KEY, "true");
  //   const matchedRoute = resolveScreenParam(location.search);
  //   history.push(matchedRoute ? `/${matchedRoute}` : '/');
  // };
  const goToHome = () => {
  localStorage.setItem(MFA_VERIFIED_KEY, "true");
  const matchedRoute = resolveScreenParam(location.search);
  window.location.href = matchedRoute ? `/${matchedRoute}` : '/';
};
  const cancel = () => { history.push("/login"); };

  const renderFormContent = () => {

    // TODO: POST SPRINT 2 — re-enable these step views after demos:
    // if (signupStep === "success") { ... }
    // if (signupStep === "mfa-choice") { ... }
    // if (signupStep === "mfa-setup") { ... }

    // Default Signup Form
    return (
      <div className={classes["signup-card"]}>
        <div className={classes["promo-badge-wrapper"]}>
          <span className={classes["promo-badge"]}>🎁 Sign up now. Unlock 2 free trial credits!</span>
        </div>
        <h2 className={classes["signup-main-title"]}>
          Benchmark your freight in 2 mins.
        </h2>

        <div className={classes["form-label"]}>
          <span>Full name <span style={{ color: "#d4453e" }}>*</span></span>
        </div>
        <div className={classes["input-group"]}>
          <input
            className={classes["input-field-new"]}
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            type="text"
            maxLength={50}
            autoComplete="name"
          />
        </div>

        <div className={classes["form-label"]}>
          <span>Work email <span style={{ color: "#d4453e" }}>*</span></span>
        </div>
        <div className={classes["input-group"]}>
          <input
            className={classes["input-field-new"]}
            placeholder="Enter your work email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            maxLength={50}
            autoComplete="email"
          />
        </div>

        <div className={classes["form-label"]}>
          <span>Password <span style={{ color: "#d4453e" }}>*</span></span>
        </div>
        <div className={classes["input-group"]} style={{ position: "relative" }}>
          <input
            className={classes["input-field-new"]}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            type={passwordVisible ? "text" : "password"}
            autoComplete="new-password"
          />
          <span onClick={() => setPasswordVisible(!passwordVisible)} className={classes["toggle-password-new"]}>
            <i className={passwordVisible ? "far fa-eye-slash" : "far fa-eye"}></i>
          </span>
        </div>
        <div className={classes["password-helper"]}>
          Min. 8 characters with a mix of letters and numbers.
        </div>

        <div className={classes["terms-text-new"]}>
          By signing up you agree to our <a href="https://lntermsandconditions.blob.core.windows.net/tnc/benchmark_tnc.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://lntermsandconditions.blob.core.windows.net/tnc/privacypolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </div>

        {error && (
          <div className={classes["error-container"]}>
            {error.startsWith("Account creation failed") ? (
              <div className={classes["error-contact"]}>
                <span className={classes["error-contact-title"]}>Account creation failed.</span>
                <span className={classes["error-contact-body"]}>
                  {" "}Please contact team LoRRI at{" "}
                  <a href="mailto:connect@logisticsnow.in" className={classes["error-contact-link"]}>connect@logisticsnow.in</a>
                  {" "}or call{" "}
                  <a href="tel:+919867773508" className={classes["error-contact-link"]}>+91-9867773508</a>
                  {" "}/{" "}
                  <a href="tel:+919653620207" className={classes["error-contact-link"]}>+91-9653620207</a>.
                </span>
              </div>
            ) : (
              <center className={classes["error-message"]}>{error}</center>
            )}
          </div>
        )}

        <button
          className={classes["submit-btn"]}
          onClick={() => register(email)}
        >
          Create account &rarr;
        </button>

        <div className={classes["security-info"]} style={{ justifyContent: "center" }}>
          <div className={classes["login-link-container"]}>
            Already have an account?{" "}
            <span className={classes["login-link"]} onClick={cancel}>
              Sign In
            </span>
          </div>
        </div>
      </div>
    );
  };

  // verify-email step renders VerifyEmailScreen as a full-page replacement
  // (it has its own logo + card layout, so we skip the two-column wrapper)
  if (signupStep === "verify-email") {
    return (
      <div className={`${classes["master-container"]}`}>
        <Loader show={show} />
        <div
          style={{ width: "100vw", minHeight: "100vh" }}
          className={`row position-relative m-0 ${classes["main-row"] || ""}`}
        >
          {/* AuthLeftPanel is hidden on mobile via its own responsive CSS */}
          <AuthLeftPanel />
          <div className={`col-md-6 ${classes["column-add"]} p-0`}>
            <VerifyEmailScreen
              email={email}
              onVerified={handleSignupVerified}
              onBack={cancel}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${classes["master-container"]}`}>
      <Loader show={show} />
      <div style={{ width: "100vw" }} className="row position-relative m-0">
        <AuthLeftPanel />
        <div className={`col-md-6 ${classes["column-add"]} p-0`}>
          <div className={classes["right-content-wrapper"]}>
            <div className={`${classes["right-logo-container"]}`}>
              <img
                alt="LoRRI logo"
                className={classes["right-logo"]}
                src={Urls.LorriLogoLogin}
              />
            </div>
            {renderFormContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;